var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaymentPanel',{attrs:{"title":_vm.$t('payment.title'),"student_id":_vm.student_id,"student_mode":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }